import React, { useCallback, useEffect, useState } from "react";
import "./Dashboard.css";
import "./PopUp.css";
import "../WNewUserTutorials/PopupBoxStyle.css";

import {
  New_ScrollX2025,
  SX_dashboard_right_arrow,
  SX_dashboard_star,
  Scrollx_animate,
  WavingHand,
  info,
  laptopScreenV3,
} from "../../assets/icons";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProjectsByPagination } from "../../Redux/actions/projectsActions";
import {
  createProject,
  deleteAProject,
  createAGoogleProject,
  renameProject,
  updateProjectStatus,
  createCardProject,
} from "../../Redux/actions/projectActions";
import {
  skipUserModel,
  allTemplatesList,
  getCurrentPlan,
  userSeenTutorial,
  selectedPageOption,
} from "../../Redux/actions/commonActtion";
import {
  AiOutlineDelete,
  AiOutlineSortDescending,
  AiOutlineSortAscending,
} from "react-icons/ai";
import { FaChevronLeft, FaClone } from "react-icons/fa";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { SiGooglesheets } from "react-icons/si";
// import { toast } from "react-toastify";
import { read, utils } from "xlsx";

import { NavBar, UI_Modal_success } from "../../UiComponents/index";
import { excelDataToProjectData } from "../../services/excelDataToProjectData";
import CloneProjectModal from "../ProjectV2/CloneProject/CloneProjectModal";
import UserInputModal from "./userInputModal";
import { Loader, Button, Dropdown_Status, Loader2 } from "../../Components";
import SuccessModal from "./SuccessModal";
import Templates from "./Templates";
import ScrollTemp from "./ScrollTemp";

import { FaChevronRight } from "react-icons/fa";
import { LuLoader2 } from "react-icons/lu";
import ProjectSkeleton from "../../Components/SkeletonLoader/ProjectSkeleton";
import Navbar from "../ProjectV2/Navbar/Navbar";
import { toast, ToastContainer } from "react-toastify";
import CustomToast, {
  defaultcustomToatStyle,
} from "../../Components/CustomToast/CustomToast";

export default function Dashboard(setIsPreviewOpen) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSent, setIsSent] = useState(false);
  const [isProjectOpen, setIsProjectOpen] = useState(false);

  const [dateSort, setDateSort] = useState("desc");
  const [isNoticeDisplay, setIsNoticeDisplay] = useState(false);
  const [projectCloneModalOpen, setProjectCloneModalOpen] = useState(false);
  const [newProjectInputModalOpen, setNewProjectInputModalOpen] =
    useState(false);

  const [ProjectType, setProjectType] = useState("scroll");
  const [projectName, setProjectName] = useState("");
  const [resolution, setResolution] = useState("");
  // console.log("ProjectType ", ProjectType, "   resolution = ", resolution);

  const [loading, setLoading] = useState(false);
  const [loadOnClone, setLoadOnClone] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [projectLimitModal, setProjectLimitModal] = useState(false);
  const [cloneMsg, setCloneMsg] = useState(false);
  const [allprojectloading, setAllProjectLoading] = useState(false);
  const [production, setProduction] = useState(false);
  const [template, setTemplate] = useState(false);
  const [templateId, setTemplateId] = useState(0);
  const [projectIdForClone, seProjectIdForClone] = useState("");
  const [renameModal, setRenameModal] = useState({
    id: "",
    isOpen: false,
    title: "",
    isCard: false,
  });

  const [options, setOptions] = useState([
    { label: "No Status", value: "defaultStatusClass" },
    { label: "Approved", value: "approvedClass" },
    { label: "In Progress", value: "inProgressClass" },
    { label: "Need Review", value: "needsReviewClass" },
  ]);

  const [size, setSize] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const getStorageData = JSON.parse(localStorage.getItem("skipModels"));
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(
    getStorageData ? getStorageData.dashModalStatus : true
  );
  const [isPopupOne, setIsPopupOne] = useState(false);
  const [isPopupsecond, setIsPopupsecond] = useState(false);
  const [isPopupThird, setIsPopupThird] = useState(false);
  // const [isPopupFour, setIsPopupFour] = useState(false);
  const [createProjectRes, setCreateProjectRes] = useState();
  const [pageNo, setPageNo] = useState(1);
  const [allTemplateLoading, setAllTemplateLoading] = useState(false);

  const updateTutorialStatus = async (status) => {
    await dispatch(userSeenTutorial(status));
  };

  const nextToContinue = (key, val, status) => {
    updateTutorialStatus(status);
  };

  const skipModel = () => {
    dispatch(
      skipUserModel({ dashModalStatus: false, layoutModalstatus: true })
    );
    setIsWelcomeModalOpen(false);
    localStorage.setItem(
      "skipModels",
      JSON.stringify({ dashModalStatus: false, layoutModalstatus: true })
    );
    setIsWelcomeModalOpen(false);
    setIsPopupOne(false);
    setIsPopupsecond(false);
    setIsPopupThird(false);
  };

  let { projects, totalProjects } = useSelector((state) => state?.projects);

  let projectLoadingInOnePage = window.innerWidth > 2500 ? 15 : 8;
  let totalPages = Math.ceil(totalProjects / projectLoadingInOnePage);

  const templatesList = useSelector(
    (state) => state?.commonReducer?.templates?.data
  );

  const sortByDate = (sortType) => {
    setDateSort(sortType);
    projects = projects.sort((a, b) => {
      if (sortType === "asc")
        return new Date(a.createdAt) - new Date(b.createdAt);
      else return new Date(b.createdAt) - new Date(a.createdAt);
    });
  };

  useEffect(
    (dateSort) => {
      sortByDate(dateSort);
    },
    [projects, setDateSort]
  );

  const detectSize = () => {
    setSize({ winWidth: window.innerWidth, winHeight: window.innerHeight });
  };
  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [size]);

  const handleChangeStatus = (index, value, project_id, isCard) => {
    const idx = options.findIndex((opt) => opt.value === value);
    dispatch(updateProjectStatus(project_id, value, idx, isCard));
  };

  const getAllProject = () => {
    setAllProjectLoading(true);
    dispatch(getCurrentPlan());
    dispatch(
      getProjectsByPagination("", projectLoadingInOnePage, pageNo, "")
    ).then(() => {
      setAllProjectLoading(false);
    });
  };

  const getAllTemplates = () => {
    setAllTemplateLoading(true);
    dispatch(allTemplatesList()).then(() => {
      setAllTemplateLoading(false);
    });
  };

  const increment = () => {
    setPageNo(pageNo < totalPages ? pageNo + 1 : pageNo);
  };

  const decrement = () => {
    setPageNo(pageNo > 1 ? pageNo - 1 : pageNo);
  };

  useEffect(() => {
    getAllProject();
    if (window.location.href.endsWith("dashboard")) {
      document.getElementById("navbar_0")?.classList?.remove("hidden");
    }
  }, [pageNo]);

  useEffect(() => {
    getAllTemplates();
  }, []);

  const handleFileInput = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const binaryStr = evt.target.result;
        const wb = read(binaryStr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = utils.sheet_to_json(ws, { header: 1 });
        const fileNameWithoutExt = file.name.split(".").slice(0, -1).join(".");
        const projectData = excelDataToProjectData(
          fileNameWithoutExt,
          jsonData
        );
        dispatch(createProject(projectData));
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      console.log(err);
    }
  };

  const handleProjectCreateError = (res) => {
    const errorMessage = res?.message || res?.response?.data?.message || "";
    const isProjectLimitError =
      res?.response?.status === 403 ||
      errorMessage.toLowerCase().includes("plan allows only");

    if (isProjectLimitError) {
      setProjectLimitModal(true);
    } else {
      toast.error("Something Is Wrong");
    }
    setProjectName("");
  };

  const handleGoogleProjectCreateButtonClick = async () => {
    try {
      if (projectName && ProjectType === "card") {
        // console.log("Submit Handler for card ", ProjectType, projectName, resolution);
        await setLoading(true);
        const res = await dispatch(
          createCardProject(projectName, templateId, resolution)
        );
        setCreateProjectRes(res?.success);
        if (res?.success) {
          setNewProjectInputModalOpen(false);
          await setLoading(false);
          setProjectName("");
          setSuccessModal(true);
        } else {
          await setLoading(false);
          handleProjectCreateError(res);
        }
      } else {
        // console.log(" Submit Handler For Scroll ", ProjectType, projectName, resolution);
        await setLoading(true);
        const res = await dispatch(
          createAGoogleProject(projectName, templateId)
        );
        setCreateProjectRes(res?.success);
        if (res?.success) {
          setNewProjectInputModalOpen(false);
          await setLoading(false);
          setProjectName("");
          setSuccessModal(true);
        } else {
          await setLoading(false);
          handleProjectCreateError(res);
        }
      }
    } catch (err) {
      await setLoading(false);
    }
  };
  
    const OptionHandler = (val, projectId, isCard) => {
      dispatch(selectedPageOption(val, projectId, isCard));
    };

  const navigateToProject = (projectId, isCard) => {
    OptionHandler("projectLayout", projectId, isCard || false);
    if(isCard){
      navigate(`/dashboard/card/${projectId}`, { state: {isDashboard:false, isCard: isCard } });
    }else{
      navigate(`/dashboard/scroll/${projectId}`, { state: {isDashboard:false, isCard:false } });
    }    
  };

  const handleNavigate = (projectId, isCard) => {  
    navigateToProject(projectId, isCard);    
    localStorage.setItem(
      "isCard",
      JSON.stringify(isCard === true ? true : false)
    );
  };

  useEffect(() => {
    setIsProjectOpen(true);
  }, [navigateToProject]);

  const deleteProject = (projectId, projectName, isCard) => {
    // const confirm = window.confirm(
    //   `Are you sure! You want to delete project (${projectName})?`
    // );
    // if (confirm) dispatch(deleteAProject(projectId, isCard));

    const handleConfirm = (closeToast) => {
      console.log(" 1  is Confirm");
      dispatch(deleteAProject(projectId, isCard));
      closeToast();
      setSuccessModal(true);
      setSuccessMsg(`Project has been successfully deleted.`);
    };

    toast(
      ({ closeToast }) => (
        <CustomToast
          title="Are you sure!"
          content={
            <>
              You want to delete project <br /> ({projectName})?
            </>
          }
          onConfirm={() => handleConfirm(closeToast)}
          onCancel={closeToast}
        />
      ),
      defaultcustomToatStyle
    );
  };

  const handleNewProjectName = async () => {
    if (projectName) {
      await setNewProjectInputModalOpen(false);
      handleGoogleProjectCreateButtonClick();
    }
  };

  const handleRenameProjec = async () => {
    const res = await dispatch(
      renameProject(renameModal?.id, renameModal?.title, renameModal?.isCard)
    );
    if (res?.success) {
      setRenameModal((prev) => ({
        ...prev,
        isOpen: false,
        title: "",
        id: "",
        isCard: false,
      }));
      // toast.success(res?.message);

      setTimeout(() => {
        toast(
          <CustomToast title="" content={res?.message} />,
          defaultcustomToatStyle
        );
      }, 300);
    } else {
      toast.error("!Oops Something Is Wrong");
    }
  };

  const skeletonComponent = () => {
    let skeletonArr = [];
    let lastPageSkeleton = totalProjects % projectLoadingInOnePage;
    let noOfSkeleton =
      totalPages === pageNo ? lastPageSkeleton : projectLoadingInOnePage;
    for (let i = 0; i < noOfSkeleton; i++) {
      skeletonArr.push(<ProjectSkeleton key={i} />);
    }
    return skeletonArr;
  };

  const CloseButton = ({ closeToast }) => (
    <i
      className=" w-7 h-7 flex justify-center cursor-pointer not-italic relative right-[20px]"
      onClick={closeToast}
    >
      ✖
    </i>
  );



  return (
    <>
      {" "}
      <ToastContainer closeButton={CloseButton}  bodyClassName={() => "p-2 min-w-[100%]"} />
      {loadOnClone ? (
        <div className="modal-overlayLoader">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80"
            width="140px"
            height="140px"
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">
            Duplicating Project...
          </p>
        </div>
      ) : null}
      <div
        className={"tainer w-full h-full"}
        // isOpen={isWelcomeModalOpen}
        // onRequestClose={continueToHomeDashboard}
        contentLabel="Welcome Modal"
      >
        <div
          className="PopUPoneContainer w-full h-full"
          // isOpen={isWelcomeModalOpen}
          // onRequestClose={continueToHomeDashboard}
          contentLabel="Popup Modal"
        >
          {size.winWidth > 1200 ? (
            <div className={"w-full h-full dashContainer"}>
              {/* {successMsg && <SuccessModal successModal={successModal} setSuccessModal={setSuccessModal} deleteMsg={successMsg}/>} */}
              <div className="dashHead">
                <NavBar />
                {/* <Navbar isProjectOpen={isProjectOpen} setIsProjectOpen={setIsProjectOpen}/> */}
              </div>

              <div className="main_dash_block dashBody">
                <div className="main_dash_div">
                  {(newProjectInputModalOpen || renameModal) && (
                    <UserInputModal
                      newProjectInputModalOpen={newProjectInputModalOpen}
                      setNewProjectInputModalOpen={setNewProjectInputModalOpen}
                      ProjectType={ProjectType}
                      setProjectType={setProjectType}
                      projectName={projectName}
                      setProjectName={setProjectName}
                      setResolution={setResolution}
                      handleNewProjectName={handleNewProjectName}
                      renameModal={renameModal}
                      setRenameModal={setRenameModal}
                      handleRenameProjec={handleRenameProjec}
                    />
                  )}
                  {loading ? (
                    <div className="modal-overlayLoader">
                      <Loader2 label={"Project Creating..."} />
                    </div>
                  ) : null}
                  {successModal && (
                    <SuccessModal
                      successModal={successModal}
                      setSuccessModal={setSuccessModal}
                      cloneMsg={cloneMsg}
                      setCloneMsg={setCloneMsg}
                      deleteMsg={successMsg}
                    />
                  )}
                  {projectLimitModal && (
                    <UI_Modal_success
                      isOpen={projectLimitModal}
                      closeModal={() => setProjectLimitModal(false)}
                      title="Project limit reached"
                    >
                      <div className="w-full px-5 pt-5 pb-4 text-white">
                        <div className="mx-auto max-w-[420px] text-center">
                          <h1 className="manrope-600 text-[22px] leading-8 text-center">
                            You can’t create another project on your current plan.
                          </h1>
                          <p className="manrope-400 text-[15px] text-[#d8d4ff] mt-4 leading-7">
                            This plan includes one active project of this type per
                            billing cycle. Upgrade your plan or contact support
                            when you’re ready to start another project.
                          </p>
                        </div>
                      </div>

                      <div className="flex justify-center pt-1">
                        <button
                          className="manrope-600 text-base text-white rounded-[10px] bg-[#4b3fcb] px-[30px] py-[8px] border-[1px] border-[#ffffff33]"
                          onClick={() => setProjectLimitModal(false)}
                        >
                          Close
                        </button>
                      </div>
                    </UI_Modal_success>
                  )}
                  {projectIdForClone && projectCloneModalOpen && (
                    <div className="">
                      <CloneProjectModal
                        projectCloneModalOpen={projectCloneModalOpen}
                        setProjectCloneModalOpen={setProjectCloneModalOpen}
                        projectId={projectIdForClone}
                        setCloneMsg={setCloneMsg}
                        setSuccessModal={setSuccessModal}
                        loading={loadOnClone}
                        setLoading={setLoadOnClone}
                        projectType={ProjectType}
                        onProjectLimitError={() => setProjectLimitModal(true)}
                      />
                    </div>
                  )}

                  <div className="DashBoardContainer w-full h-full  ">
                    <div className="bg-black w-full h-[43%]  flex justify-center items-center">
                      <div className="right_add_block w-[85%] h-[70%] rounded-[1.5rem]">
                        <div className="w-full h-full flex items-center flex-col justify-center rounded-[1.5rem] py-7 ">
                          <div className=" w-full flex items-center justify-between pl-[4%] pr-[3.5%]">
                            <div className="flex">
                              <h1 className="right_heading_text manrope-800 pb-[26px]  pr-[10px]">
                                Select a Template to Get Started
                              </h1>
                              <img
                                className="w-8 h-6"
                                src={SX_dashboard_star}
                                alt=""
                              />
                            </div>
                            <div className="">
                              <img
                                className="w-5"
                                src={info}
                                alt=""
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  window.open(`/help/66f25db207e246eced9ecfda`)
                                }
                              />
                            </div>
                          </div>
                          <div className="w-full">
                            <div className="w-[100%] h-fit  snap_inline">
                              <ScrollTemp
                                template={template}
                                templatesList={templatesList}
                                setTemplate={setTemplate}
                                setTemplateId={setTemplateId}
                                setNewProjectInputModalOpen={
                                  setNewProjectInputModalOpen
                                }
                                allTemplateLoading={allTemplateLoading}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Project Table List */}

                    <div className="w-full h-[57%]  bg-[#121212]">
                      <div className="w-[85%] py-[30px] px-[7.5%]">
                        <h1 className="manrope-800 text-white text-2xl">
                          My Projects
                        </h1>
                      </div>
                      <div className="w-full flex flex-col justify-center">
                        <div className="w-full flex justify-center">
                          <div className="xl:w-[85%] pr-[12px] 2xl:w-[w-75%]  h-[55px] flex justify-center w-[70%] items-center  rounded-[.8rem] ShadeGrayLinear100">
                            <div className="text-[18px] w-[23%]   text-white  text-left manrope-600 pl-[20px]">
                              Project Name
                            </div>

                            <div className=" text-[18px] w-[13%]  text-white  flex items-center justify-center  manrope-600 ">
                              Type
                            </div>

                            <div className=" text-[18px] w-[27%] text-center text-white  flex items-center justify-center  manrope-600 ">
                              Status
                            </div>

                            <div className="text-[18px] w-[22%]   text-white  text-center flex items-center justify-center">
                              <div className="text-center text-[18px] manrope-600">
                                Created
                              </div>
                              <div
                                className="cursor-pointer"
                                onClick={() =>
                                  dateSort === "asc"
                                    ? sortByDate("desc")
                                    : sortByDate("asc")
                                }
                              >
                                {dateSort === "asc" ? (
                                  <AiOutlineSortAscending />
                                ) : (
                                  <AiOutlineSortDescending />
                                )}
                              </div>
                            </div>

                            <div className=" text-[18px] w-[25%]  text-white  flex items-center justify-center  manrope-600 ">
                              Options
                            </div>
                            <div className=" text-[18px] w-[10%]  text-white  flex items-center justify-end pr-[20px] manrope-600 ">
                              Edit Project
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Project Table List */}

                      <div className="flex  w-[100%]  h-[59%]    justify-center  overflow-auto">
                        <div className="xl:w-[85%] 2xl:w-[w-75%] overflow-auto w-[80%] pb-[40px] scroll_width1">
                          {allprojectloading ? (
                            <div className="w-[100%]">
                              {/* <LuLoader2 className="text-white text-[2rem] animate-spin m-auto mt-5"/> */}
                              {skeletonComponent()}
                            </div>
                          ) : projects && projects?.length ? (
                            projects?.map((project, index) => {
                              return project ? (
                                <>
                                  <div
                                    className="white-80 w-[100%] justify-center text-lg  dashTable  flex items-center border-b-[1px] border-[#3A3A3A] first:border-t-[1px]"
                                    key={index}
                                  >
                                    <div
                                      className="pl-[20px] text-base text-left w-[23%] capitalize white-80 manrope-600  h-12 flex items-center cursor-pointer"
                                      onClick={() =>
                                        handleNavigate(
                                          project?._id,
                                          project?.isCard
                                        )
                                      }
                                    >
                                      <span
                                        className="cursor-pointer"
                                        title={project?.title}
                                      >
                                        {project?.title.length > 25
                                          ? project?.title.slice(0, 25) + "..."
                                          : project?.title}
                                      </span>
                                      {/* <span className="cursor-pointer" onClick={()=>navigate(`/dashboard/cardLayout/${project?._id}`)}>{project?.title}</span> */}
                                    </div>

                                    <div
                                      className="w-[13%] flex items-center justify-center manrope-600 text-base curson-pointer"
                                      onClick={() =>
                                        handleNavigate(
                                          project?._id,
                                          project?.isCard
                                        )
                                      }
                                    >
                                      <span>
                                        {project?.isCard ? "Card" : "Scroll"}
                                      </span>
                                    </div>

                                    <div className="text-base  w-[27%] white-80 h-12 flex items-center justify-center  cursor-pointer">
                                      <h1 className="">
                                        <Dropdown_Status
                                          options={options}
                                          value={
                                            project?.projectStatus === ""
                                              ? "No Status"
                                              : project?.projectStatus
                                          }
                                          projectStatus={project?.projectStatus}
                                          selectedID={project?.statusId}
                                          onChange={(value) => {
                                            handleChangeStatus(
                                              index,
                                              value,
                                              project?._id,
                                              project?.isCard
                                            );
                                          }}
                                        />
                                      </h1>
                                    </div>

                                    <div
                                      className=" text-base white-80  w-[22%] h-12 text-center flex items-center justify-center  manrope-600 cursor-pointer"
                                      onClick={() =>
                                        handleNavigate(
                                          project?._id,
                                          project?.isCard
                                        )
                                      }
                                    >
                                      {new Date(
                                        project?.createdAt
                                      ).toDateString()}{" "}
                                      -{" "}
                                      {new Date(project?.createdAt)
                                        .toTimeString()
                                        .slice(0, 8)}
                                    </div>
                                    <div className="flex w-[25%] items-center justify-center">
                                      <div className="pr-2  relative">
                                        <span
                                          className=" cursor-pointer white-80 edit"
                                          onClick={() =>
                                            setRenameModal((prev) => ({
                                              ...prev,
                                              isOpen: true,
                                              id: project?._id,
                                              title: project?.title,
                                              isCard: project?.isCard,
                                            }))
                                          }
                                        >
                                          {/* <img className="mt-[4px] w-[25px]" src={Write} alt="" /> */}
                                          <MdOutlineDriveFileRenameOutline />
                                        </span>
                                      </div>
                                      <div className=" relative">
                                        <div
                                          className="px-2 white-80 clone"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            setProjectCloneModalOpen(true);
                                            seProjectIdForClone(project?._id);
                                            setProjectType(
                                              project?.isCard
                                                ? "card"
                                                : "scroll"
                                            );
                                          }}
                                        >
                                          {/* <img className="w-[19px]" src={duplicate} alt="" /> */}

                                          <FaClone />
                                        </div>
                                      </div>

                                      <div className="px-2 relative">
                                        <div className="flex  white-80 text-xl ">
                                          {project?.googleSheetLink ? (
                                            <span
                                              className=" sheet cursor-pointer"
                                              onClick={() =>
                                                window.open(
                                                  project?.googleSheetLink
                                                )
                                              }
                                            >
                                              {/* <img className="w-[10px]" src={dshCredit} alt="" /> */}

                                              <SiGooglesheets />
                                            </span>
                                          ) : project?.googleSpreadSheetId ? (
                                            <span
                                              className="px-2 cursor-pointer white-80"
                                              onClick={() =>
                                                window.open(
                                                  `https://docs.google.com/spreadsheets/d/${project?.googleSpreadSheetId}`
                                                )
                                              }
                                            >
                                              {/* <img className="w-[15px]" src={dshCredit} alt="" /> */}
                                              <SiGooglesheets />
                                            </span>
                                          ) : null}
                                        </div>
                                      </div>

                                      <div className="px-2 relative">
                                        <span
                                          className=" cursor-pointer white-80 delete"
                                          onClick={() =>
                                            deleteProject(
                                              project?._id,
                                              project?.title,
                                              project?.isCard
                                            )
                                          }
                                        >
                                          {/* <img className="w-[15px]" src={dshDelete} alt="" /> */}
                                          <AiOutlineDelete />
                                        </span>
                                      </div>
                                    </div>
                                    <div className="w-[10%] flex justify-center items-center text-center">
                                      <img
                                        onClick={() =>
                                          handleNavigate(
                                            project?._id,
                                            project?.isCard
                                          )
                                        }
                                        className="  w-[24px] cursor-pointer"
                                        src={SX_dashboard_right_arrow}
                                        alt=""
                                      />
                                    </div>

                                    {/* <td>
                                  <span
                                    className="mx-2 cursor-pointer text-zink-600"
                                    onClick={() =>
                                      navigateToProject(project._id)
                                    }
                                  >
                                    <GrLinkNext/>
                                  </span>
                                </td> */}
                                  </div>
                                </>
                              ) : (
                                ""
                              );
                            })
                          ) : (
                            <tr>
                              <td>
                                <p className="all_project_loading pl-[20px] pt-[20px]">
                                  Create Project to Get Started
                                </p>
                              </td>
                            </tr>
                          )}
                        </div>
                      </div>
                      {totalProjects > projectLoadingInOnePage && (
                        <div className="  manrope-800 h-[11%] select-none text-white flex justify-center gap-[1rem]  items-center w-full">
                          <p
                            className="Fmanrope-800 flex text-sm 3xl:text-base items-center cursor-pointer hover:text-gray-400"
                            onClick={decrement}
                          >
                            <FaChevronLeft />
                            prev
                          </p>
                          <p className="manrope-800 text-[0.8rem]">
                            {pageNo} / {totalPages}
                          </p>
                          <p
                            className="manrope-800 flex text-sm 3xl:text-base items-center cursor-pointer hover:text-gray-400"
                            onClick={increment}
                          >
                            next
                            <FaChevronRight onClick={increment} />
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* ==================(1  WELCOME POPUP)==================== */}
              <div
                className={
                  isWelcomeModalOpen === true ? "wmcOverlay" : "wmcOverlayNone"
                }
              >
                {" "}
                <div className="w-full h-full wmcOverlaySecond backdrop-blur-sm"></div>
              </div>

              {isWelcomeModalOpen && (
                <div
                  className={
                    size.winWidth < 1000 ? "hideComp" : "welcomeContent"
                  }
                >
                  <div className="w-full h-full flex flex-col justify-center items-center">
                    <div className="w-full flex justify-start items-center cursor-default ">
                      <h1 className="text-left text-white text-3xl tracking-wide manrope-800">
                        Take a quick tour to <br />
                        create your end credits
                      </h1>
                    </div>

                    <div className="w-full pt-[15px] pb-4 flex flex-col justify-start items-center">
                      <p className="text-base w-full  text-left manrope-400 text-white cursor-default">
                        Watch a short 2-minute walkthrough to quickly learn
                      </p>
                      <p className="text-base w-full  text-left manrope-400 text-white cursor-default">
                        how to create, edit, and render end credits with ease.
                      </p>
                    </div>

                    <div className="w-full flex flex-col justify-center align-center">
                      <button
                        className="w-full mb-4 rounded-xl py-[10px] text-white text-center bg-[#5e51d1] text-[1em] manrope-600"
                        onClick={() => {
                          skipModel(); 
                          window.open('/help/', '_blank'); // navigate to /help/ in the same tab
                        }}
                      >
                        
                          Watch 2-Minute Video Now
                      
                      </button>
                      <button
                        className="text-white rounded-xl  py-[10px] bg-[#2a2b36] w-full text-center text-[1em] manrope-400"
                        onClick= {skipModel}
                      >
                        Skip
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div
              id="warning-messageas"
              style={{ width: "100%", height: "100%" }}
            >
              <div className="w-full h-full ">
              
              {/* ============== */}
                 <div
      className="relative min-h-screen overflow-x-hidden antialiased text-base leading-[1.6] text-sx-ink bg-[#06050c] bg-fixed"
      style={{
        fontFamily: "var(--font-body)",
        backgroundImage:
          "radial-gradient(circle at 50% 0%, rgba(124,92,255,.1) 0%, transparent 45%), radial-gradient(circle at 20% 90%, rgba(124,92,255,.06) 0%, transparent 50%)",
      }}
    >
      {/* Keyframes only — can't be expressed as Tailwind utilities without config */}
      <style>{`
        @keyframes swd-drift { from { background-position: 0 0; } to { background-position: 200px 200px; } }
        @keyframes swd-pulse { 0%,100% { opacity:.6; transform:scale(.96); } 50% { opacity:1; transform:scale(1.04); } }
        @keyframes swd-twinkle { 0%,100% { opacity:.25; transform:scale(.85); } 50% { opacity:1; transform:scale(1.1); } }
        @media (prefers-reduced-motion:reduce) { .swd-a { animation:none !important; } }
      `}</style>

      {/* Noise overlay */}
      <div
        className="fixed inset-0 pointer-events-none z-[9998] opacity-[.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Particles */}
      <div
        className="swd-a fixed inset-0 pointer-events-none z-0 [background-size:200px_200px] [animation:swd-drift_50s_linear_infinite]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 15% 50%,rgba(255,255,255,.08) 1px,transparent 1px),radial-gradient(circle at 85% 30%,rgba(124,92,255,.14) 1.5px,transparent 1.5px),radial-gradient(circle at 50% 80%,rgba(255,255,255,.05) 2px,transparent 2px),radial-gradient(circle at 70% 90%,rgba(124,92,255,.1) 1px,transparent 1px),radial-gradient(circle at 30% 20%,rgba(255,255,255,.1) 1.5px,transparent 1.5px),radial-gradient(circle at 10% 85%,rgba(124,92,255,.16) 1px,transparent 1px),radial-gradient(circle at 90% 60%,rgba(255,255,255,.06) 2px,transparent 2px)",
        }}
      />

      <main className="relative z-[1] min-h-screen mblScreen flex items-center justify-center py-14 px-6">
        <div className="max-w-[440px] w-full text-center">

          {/* Logo */}
          {/* <Link to="/" className="inline-flex items-center gap-[10px] font-semibold text-[15px] tracking-[-0.01em]">
            <div className="w-8 h-8 rounded-[8px] bg-gradient-to-br from-sx-violet2 to-sx-violet flex items-center justify-center">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 8l6 4-6 4M13 16h7" />
              </svg>
            </div>
            ScrollX
          </Link> */}

          <header className="">
            <nav className="w-full flex justify-center">
              <div className="">
                <Link to="/" className="nav-logo">
                  <span className="nav-logo-icon"><img className="logo-img999 " src={New_ScrollX2025} alt="icon" /></span>
                  <span className="text-white sm:block xl:text-[15px] manrope-300 ">ScrollX</span>
                </Link>
              </div>
            </nav>
          </header>

          <h1 className="mt-8 text-[clamp(30px,7vw,38px)] text-white font-bold leading-[1.15] tracking-[-0.03em]">
            You're in.<br />
            <em className="not-italic font-light text-sx-violet3">Grab a bigger screen.</em>
          </h1>
          <p className="mt-4 text-[15px] text-sx-dim text-white leading-[1.65]">
            Your plan is active and ready to go. ScrollX's drag-and-drop editing, live 4K preview, and multi-track syncing all feel best on a laptop or desktop.
          </p>

          {/* Device illustration */}
          <div className="relative mx-auto mt-[44px] mb-9 w-[240px] h-[150px]">
            <div
              className="swd-a absolute rounded-full [animation:swd-pulse_3.2s_ease-in-out_infinite]"
              style={{
                inset: "-20px",
                background: "radial-gradient(circle, rgba(124,92,255,.22) 0%, transparent 65%)",
              }}
            />
            <svg className="relative w-full h-full" viewBox="0 0 220 130" fill="none">
              {/* phone */}
              <rect x="14" y="25" width="42" height="78" rx="9" stroke="#5a577a" strokeWidth="2" />
              <rect x="30" y="92" width="10" height="3" rx="1.5" fill="#5a577a" />
              {/* arrow */}
              <path d="M60 64 C 72 64, 78 50, 90 44" stroke="#c4b2ff" strokeWidth="2" strokeDasharray="4 5" strokeLinecap="round" />
              <path d="M83 38 L92 44 L84 50" stroke="#c4b2ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
              {/* sparkles */}
              <path className="swd-a [animation:swd-twinkle_2.4s_ease-in-out_infinite] [transform-origin:center]" d="M168 8 l2 6 6 2 -6 2 -2 6 -2 -6 -6 -2 6 -2 z" fill="#c4b2ff" />
              <path className="swd-a [animation:swd-twinkle_2.4s_ease-in-out_infinite_.5s] [transform-origin:center]" d="M206 30 l1.5 4.5 4.5 1.5 -4.5 1.5 -1.5 4.5 -1.5 -4.5 -4.5 -1.5 4.5 -1.5 z" fill="#9d7dff" />
              <path className="swd-a [animation:swd-twinkle_2.4s_ease-in-out_infinite_1s] [transform-origin:center]" d="M196 92 l1.5 4.5 4.5 1.5 -4.5 1.5 -1.5 4.5 -1.5 -4.5 -4.5 -1.5 4.5 -1.5 z" fill="#c4b2ff" />
              {/* monitor */}
              <rect x="84" y="8" width="122" height="78" rx="10" fill="rgba(124,92,255,.08)" stroke="#9d7dff" strokeWidth="2.5" />
              <rect x="120" y="90" width="50" height="6" rx="3" fill="#9d7dff" opacity=".4" />
              <path d="M132 86 L122 96 M158 86 L168 96" stroke="#9d7dff" strokeWidth="2" strokeLinecap="round" opacity=".5" />
              <rect x="98" y="26" width="50" height="4" rx="2" fill="#c4b2ff" opacity=".5" />
              <rect x="98" y="38" width="70" height="4" rx="2" fill="#c4b2ff" opacity=".35" />
              <rect x="98" y="50" width="40" height="4" rx="2" fill="#c4b2ff" opacity=".25" />
              <rect x="98" y="62" width="58" height="4" rx="2" fill="#c4b2ff" opacity=".2" />
            </svg>
          </div>

          <h2 className="mt-1 text-[clamp(20px,5vw,25px)] text-white font-bold tracking-[-0.02em] leading-[1.25]">
            Built for <em className="not-italic font-light text-sx-violet3">the big screen.</em>
          </h2>
          <p className="mt-[14px] text-[14.5px] text-sx-dim text-white leading-[1.7]">
            Open ScrollX on your laptop or desktop and we'll have everything ready, no need to redo anything.
          </p>

          {/* CTA */}
          <button
            type="button"
            className="group w-full mt-8 p-3 text-[15px] font-medium text-white bg-sx-violet rounded-[10px] border-0 cursor-pointer transition-all duration-200 inline-flex items-center justify-center gap-2 hover:bg-sx-violet2 hover:-translate-y-px hover:shadow-[0_8px_32px_rgba(124,92,255,.35)] disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ fontFamily: "var(--font-body)" }}
            onClick={() => setIsSent(true)}
            disabled={isSent}
          >
            {isSent ? (
              "Link sent"
            ) : (
              <>
                Email Me The Link
                <span className="text-[18px] transition-transform duration-200 group-hover:translate-x-0.5">→</span>
              </>
            )}
          </button>

          {isSent && (
            <div className="mt-[14px] flex items-center justify-center gap-2 bg-[rgba(124,92,255,.1)] border border-[rgba(124,92,255,.25)] rounded-[10px] py-[11px] px-[14px] text-[13px] text-sx-violet3 text-white">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Sent. Check your inbox.
            </div>
          )}

          <p className="mt-[22px] text-[13px] text-sx-faint leading-[1.6] text-white">
            Or just head to{" "}
            <strong className="text-sx-dim font-medium">app.scrollx.io</strong>
            {" "}next time you're at your computer.
          </p>

        </div>
      </main>
    </div>
              {/* ============== */}

              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}